<template>
<div class="smsc-container">
  <vx-card>
    <div slot="no-body" class="flex flex-wrap items-center justify-between pl-3 pr-3">
      <div class="buttons-container flex flex-wrap items-center justify-start pb-3">
        <vs-button
          class="mt-3"
          @click="$router.go(-1)"
        >Back to User</vs-button>
      </div>
      <div class="buttons-container flex flex-wrap items-center justify-end pb-3">
        <vs-button
          color="danger"
          class="mt-3 mr-3 mr-md-0"
          @click="$router.go(-1)"
        >Cancel</vs-button>
        <vs-button
          class="mt-3"
          @click="Edit"
        >Save Edit</vs-button>
      </div>
    </div>
  </vx-card>
  <vx-card>
    <div style="padding: 11px">
      <smsc-col>
        <smsc-col-item :col-quantity="2"  :mt="0">
          <vs-input
            v-validate="'required'"
            data-vv-validate-on="input"
            name="first name"
            class="w-100"
            :class="{'is-danger': errors.has('first name')}"
            type="text"
            label=" FIRST NAME"
            placeholder="FIRST NAME"
            v-model="payload.first_name"
          />
          <span class="text-danger help text " v-if="errors.has('first name')">{{ errors.first('first name') }}</span>
        </smsc-col-item>
        <smsc-col-item  :col-quantity="2" :mt="0">
          <vs-input
            v-validate="'required'"
            data-vv-validate-on="input"
            name="last name"
            class="w-100"
            :class="{'is-danger': errors.has('last name')}"
            type="text"
            label=" LAST NAME"
            placeholder="LAST NAME"
            v-model="payload.last_name"
          />
          <span class="text-danger help text " v-if="errors.has('last name')">{{ errors.first('last name') }}</span>
        </smsc-col-item>
        <smsc-col-item :col-quantity="2"  :mt="0">
          <vs-input
            data-vv-validate-on="input"
            name="user name"
            class="w-100 "
            :class="{'is-danger': errors.has('user name')}"
            type="text"
            label=" USER NAME"
            placeholder="USER NAME"
            v-model="payload.user_name"
          />
        </smsc-col-item>
        <smsc-col-item :col-quantity="2"  :mt="0">
          <label class="vs-input--label">LOCATION</label>
          <v-select
            data-vv-validate-on="input"
            name="STATUS"
            placeholder="Enter Status"
            :class="{'is-danger': errors.has('STATUS')}"
            label="name"
            :reduce="(option) => option.value"
            :options="status"
            v-model="payload.status"
          />
        </smsc-col-item>



        <smsc-col-item :col-quantity="2"  :mt="0">
          <vs-input
            v-validate="'required'"
            data-vv-validate-on="input"
            name="Password"
            ref="password"
            class="w-100"
            :class="{'is-danger': errors.has('Password')}"
            type="password"
            placeholder="********"
            label="PASSWORD"

            v-model="payload.passwd"
          />
          <span class="text-danger help text " v-if="errors.has('Password')">{{ errors.first('Password') }}</span>
        </smsc-col-item>
        <smsc-col-item  :col-quantity="2" :mt="0">
          <vs-input
            v-validate="'required|confirmed:password'"
            data-vv-validate-on="input"
            data-vv-as="Confirmed password"
            name="Confirmed_password"
            class="w-100 "
            :class="{'is-danger': errors.has('Confirmed_password')}"
            type="password"
            placeholder="********"
            label="RE-ENTER PASSWORD"

            v-model="payload.confirm_password"
          />
          <!--            v-validate="' min:6|max:12|confirmed:Password'"-->
          <span class="text-danger help text " v-if="errors.has('Confirmed_password')">{{ errors.first('Confirmed_password') }}</span>
        </smsc-col-item>
        <smsc-col-item :col-quantity="2"  :mt="0">
          <label for="Allowed_API_IP" class="ip-label">ALLOWED SMPP IP</label>
          <vue-ip-input
            id="Allowed_API_IP"
            :on-change="onIpChange"
            :ip="ip"
            v-model="payload.allowed_api_ip_list"
            v-validate="'required|ip'"
            name="ALLOWED SMPP IP"
            class="w-100 vue-input-ip"
            :class="{'is-danger': errors.has('Allowed_API_IP')}"
            type="text"
          />
          <span class="text-danger help text ">{{ errors.first('Allowed_API_IP') }}</span>
        </smsc-col-item>

      </smsc-col>
    </div>
  </vx-card>
</div>
</template>

<script>
  // Packages
  import axios from '@/axios.js'
  import VueIpInput from 'vue-ip-input';
  import vSelect from 'vue-select'
  import {format} from "date-fns";

  export default {
    components: {
      VueIpInput,
      vSelect
    },
    data() {
      return {
        // Dropdowns
        countries: [],
        search_user_name:"",
        // Selects value
        ip:'',
        allowed_api_ip_list: '',
        status:[ { name: 'Active', value: 'active' },{ name: 'Inactive', value: 'inactive' },],
        status_value: {},
        selected: {
          mode: null,
          reseller_uuid: null,
          country_uuid: null,
          payment_term_uuid: null,
          phone_code: null
        },

        // Request body
        payload: {
          reseller_name: null,
          companies: [],
          allowed_api_ip_list:null,
          //  address: null,
          //  city: null,
          // country_uuid: null,
          //    email: null,
          first_name: null,
          last_name: null,
          logo_file_uuid: null,
          passwd: null,
          confirm_password:null,
          phone: null,
          //   state: null,
          //   zipcode: null,
          user_name:'',
          credits:'',
          allowedPrefix:'',
          user_list_user_id:""


        }
      }
    },
    created() {
      this.user_list_user_id =  this.$route.params.id.user_id
      this.FetchData()
    },
    methods: {
      async Edit() {
        // console.log(this.payload, "<----------------");

        const valid = await this.$validator.validate()
// console.log(valid,"valid")
        if (!valid) {
          return
        }
        this.$vs.loading()
        this.payload.id = this.user_list_user_id,
        this.$store.dispatch('user/Edit', { ...this.payload})
          .then(res => {
            this.$router.push({ name: 'Company_admin_user' })
            this.ShowSuccessMessage({ title: 'Success', text: 'Product has been added' })
          })
          .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
          .finally(() =>
              this.payload.username = '',
            this.payload.allowedPrefix = '',
            this.payload.credits = '',
            this.$vs.loading.close())
      },
      async FetchData()  {
        this.$vs.loading()
        this.$store.dispatch('user/GetList', {
          ...this.filters,
          user_id :this.user_list_user_id,
          page: this.page || 0,
          per_page: this.per_page || 20,
          order_by: this.order_by || 'created_on',
          order_dir: this.order_dir || 'desc',
          user_name: this.search_user_name + '*'
        })
          .then(res => {
            // this.lists = res.items
              // this.payload.user_id = res.items[0].user_id,
              this.ip = res.items[0].allowed_api_ip_list?res.items[0].allowed_api_ip_list:res.items[0].allowed_ip_list,
              this.payload.status = res.items[0].status,
              this.payload.passwd = res.items[0].passwd,
              this.payload.confirm_password = res.items[0].passwd,
              this.payload.user_name = res.items[0].user_name,
              this.payload.last_name = res.items[0].last_name,
              this.payload.first_name = res.items[0].first_name,
              this.payload.company_uuid = res.items[0].company_uuid
            this.total = res.total
          })
          .catch(err => {
            this.ShowErrorMessage({title: 'Error', text: err})
            console.log(err)
          })
          .finally(() => this.$vs.loading.close())
      },

      // Capitalize
      Capitalize (val) {
        if (!val) return ''

        return `${val.charAt(0).toUpperCase()}${val.slice(1)}`
      },
      //IP
      onIpChange(ip) {
        // console.log(ip,"************************************")
        this.payload.allowed_api_ip_list = ip
        // this.payload.allowed_ip_list = ip
      },

      // Notify
      ShowSuccessMessage ({ title, text }) {
        this.$vs.notify({
          iconPack: 'feather',
          icon: 'icon-check',
          color: 'success',
          title,
          text
        })
      },
      ShowErrorMessage ({ title, text }) {
        this.$vs.notify({
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          title,
          text
        })
      },


      // Transform functions
      TransformCountry(item) {
        return {
          name: item.nice_name,
          value: item.country_uuid
        }
      },
    }
  }
</script>
<style>
  .lab{
    margin-left: 15px;
  }

</style>
<style scoped lang="scss" >
  .vue-input-ip {
    display: inline-block!important;
    height: 41px!important;
    line-height: normal!important;
    border: 1px solid #ccc!important;
    border-radius: 4px!important;
    box-sizing: border-box!important;
    background-color: #fff!important;
    &:active {
      border: 1px solid #7366ff!important;
    }
    &:focus {
      border: 1px solid #7366ff!important;
    }
  }
  .ip-label {
    font-size: .85rem!important;
    color: rgba(0,0,0,.7) !important;
  }
</style>
